import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

// routes
import AuthenticationRoutes from "./AuthenticationRoutes";
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import SimpleRoutes from "./SimpleRoutes";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";

const PagesLanding = Loadable(lazy(() => import("views/pages/landing")));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <AuthGuard>
          <Navigate to="/rally-officer/dashboard" replace />
        </AuthGuard>
      ),
    },
    AuthenticationRoutes,
    LoginRoutes,
    SimpleRoutes,
    MainRoutes,
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME,
  },
);

export default router;
